<!-- 
    描述：审核待办  --  基础信息
    时间： 2020/10/29
    Created by zl
-->
<template>
	<div class="h100 base-info">
		<el-form ref="objectItem"
				 :model="objectItem"
				 label-width="140px"
				 size="small">
			<el-row>
				<el-col :span="11">
					<el-form-item label="姓名：">
						<el-input v-model="zjName"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11"
						:offset="1">
					<el-form-item label="身份证号码：">
						<el-input v-model="idCard"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="性别：">
						<el-radio :label="1"
								  v-model="baseInfo.sex"
								  disabled>男</el-radio>
						<el-radio :label="0"
								  v-model="baseInfo.sex"
								  disabled>女</el-radio>
					</el-form-item>
				</el-col>
				<el-col :span="11"
						:offset="1">
					<el-form-item label="民族：">
						<el-select v-model="baseInfo.nation"
								   placeholder="请选择..."
								   disabled>
							<el-option v-for="item in nationDL"
									   :key="item.value"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="出生日期：">
						<el-date-picker type="date"
										v-model="baseInfo.birthday"
										disabled></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="11"
						:offset="1">
					<el-form-item label="年龄：">
						<el-input v-model="baseInfo.age"
								  disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-divider class="divider-msg"
						content-position="left">
				<div class="divider-title">联系方式</div>
			</el-divider>
			<el-row>
				<el-col :span="11">
					<el-form-item label="邮箱地址：">
						<el-input v-model="baseInfo.email"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11"
						:offset="1">
					<el-form-item label="其他联系电话：">
						<el-input v-model="baseInfo.otherPhone"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="微信号：">
						<el-input v-model="baseInfo.wechat"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11"
						:offset="1">
					<el-form-item label="QQ：">
						<el-input v-model="baseInfo.qq"
								  disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="11">
					<el-form-item label="所在地：">
						<AddressForm v-model="zjArea"
									 :showDetail="false"
									 disabled
									 size="small"></AddressForm>
					</el-form-item>
				</el-col>
				<el-col :span="23">
					<el-form-item label="详细地址：">
						<el-input v-model="baseInfo.address"
								  disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getAge } from 'utils/tools.js'
import AddressForm from 'components/addressForm/addressForm'
export default {
	components: {
		AddressForm,
	},
	props: {
		baseInfo: {
			type: Object,
			default: () => ({}),
		},
		idCard: {
			type: String,
			default: '',
		},
		zjName: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			objectItem: {},
			isEdit: true,
			zjArea: {},
		}
	},
	mounted() {
		setTimeout(() => {
			if (this.baseInfo.area && this.baseInfo.area != '') {
				let location = this.baseInfo.area.split(',')
				this.zjArea = {
					province: {
						name: '',
						value: location[0],
					},
					city: {
						name: '',
						value: location[1],
					},
					area: {
						name: '',
						value: location[2],
					},
				}
			}
			// let birthday = this.idCard
			// birthday = birthday.substr(6, 13)
			// console.log(birthday)
		}, 500)
	},
	methods: {},
	computed: {
		...mapState('dict', {
			nationDL: (state) => state.mz, // 民族
		}),
	},
	watch: {
		'baseInfo.birthday'(val) {
			if (val && val != '') {
				this.baseInfo.age = getAge(val)
			}
		},
	},
}
</script>
<style lang="less" scoped>
.base-info {
	padding: 20px;
	.divider-title {
		display: inline-block;
		height: 32px;
		line-height: 32px;
	}
	.item {
		display: none;
	}
}
</style>
